import React from 'react';
import { useSiteSettings } from '../context/SiteSettingsContext';
import './Shipping.css';

const Shipping: React.FC = () => {
  const { settings } = useSiteSettings();
  return (
    <div className="shipping">
      <section className="section">
        <div className="container">
          <h2>Shipping</h2>

          <div className="shipping-block">
            <h3>Worldwide</h3>
            <p>Shipping can be arranged either by RORO or Container to Europe, Asia etc.</p>
          </div>

          <div className="shipping-block">
            <h3>Canada</h3>
            <p>
              Shipping is arranged via shipmyride.ca, fully insured for the value of the car.
              Expect delivery in 1-2 weeks. Buyers can also arrange their own shipping.
            </p>
          </div>

          <div className="shipping-block">
            <h3>USA</h3>
            <p>
              USA buyers can either get the car shipped to their home or fly down and drive home.
              Our nearest airport is Toronto International Airport (YYZ).
            </p>
          </div>
        </div>
      </section>

      {/* USA Details */}
      <section className="section usa-section">
        <div className="container">
          <div className="shipping-block">
            <h3>USA &ndash; Shipping</h3>
            <p>
              Shipping to USA is arranged either via TFX International or other carrier of your choice.
              Buyers are welcome to arrange their own shipping.
            </p>
            <div className="cost-rows">
              <div className="cost-row">
                <span>Canada to NJ (TFX Door to Door Enclosed)</span>
                <span className="cost-price">{settings.shippingNJ}</span>
              </div>
              <div className="cost-row">
                <span>Canada to CA (TFX Door to Door Enclosed)</span>
                <span className="cost-price">{settings.shippingCA}</span>
              </div>
              <div className="cost-row">
                <span>Canada to TX (TFX Door to Door Enclosed)</span>
                <span className="cost-price">{settings.shippingTX}</span>
              </div>
            </div>
          </div>

          <div className="shipping-block">
            <h3>USA &ndash; Driving</h3>
            <p>
              Buyers can also choose to drive their newly purchased vehicles back to the USA.
              The border paperwork is a simple process, takes about 30 mins to an hour to complete.
            </p>
          </div>

          <div className="shipping-block">
            <h3>USA &ndash; Registration</h3>
            <p>For registration in US states (except CA), you will need:</p>
            <ul className="shipping-list">
              <li>The Canadian Vehicle Ownership/Registration &ndash; Provided by us</li>
              <li>Invoice / Bill of Sale &ndash; Provided by us</li>
              <li>EPA form 3520-1 (Completed at the border by US Customs)</li>
              <li>DOT form HS-7 (Completed at the border by US Customs)</li>
            </ul>
            <p>
              More import information: <a href="https://www.cbp.gov/trade/basic-import-export/importing-car" target="_blank" rel="noopener noreferrer">cbp.gov</a>
            </p>

            <div className="cost-rows" style={{ marginTop: '1.5rem' }}>
              <div className="cost-row">
                <span>Customs Broker Fees (if you require us to clear the car for you)</span>
                <span className="cost-price">{settings.customsBrokerFee}</span>
              </div>
              <div className="cost-row">
                <span>Duty</span>
                <span className="cost-price">{settings.duty}</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Storage */}
      <section className="section">
        <div className="container">
          <div className="shipping-block">
            <h3>Storage</h3>
            <p>
              Storage can be arranged for vehicles that are not ready to be imported to your country
              of residence, for example, 25 years in the USA. We will store the vehicle as long as
              necessary, and at your request, we will drive it gently for up to a half hour every couple
              of months &ndash; except winter months (Nov &ndash; Apr), when it will be winterized and
              stored away. You are also welcome to take "your" car for a spin or to our local tracks
              any time you wish (Plates and Insurance included)! There are 3 great tracks in the Toronto
              area and more if you are willing to drive farther.
            </p>

            <h4>Storage Costs Per Month</h4>
            <div className="cost-rows">
              <div className="cost-row">
                <span>Outdoor covered</span>
                <span className="cost-price">{settings.storageOutdoor}</span>
              </div>
              <div className="cost-row">
                <span>Indoor Shared</span>
                <span className="cost-price">{settings.storageIndoorShared}</span>
              </div>
              <div className="cost-row">
                <span>Indoor Exclusive</span>
                <span className="cost-price">{settings.storageIndoorExclusive}</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Taxes */}
      <section className="section tax-section">
        <div className="container">
          <div className="shipping-block">
            <h3>Taxes</h3>
            <div className="cost-rows">
              <div className="cost-row">
                <span>Canadian Residents (HST)</span>
                <span className="cost-price">{settings.taxCanadianResidents}</span>
              </div>
              <div className="cost-row">
                <span>Non Residents &ndash; Local Pickup (HST)</span>
                <span className="cost-price">{settings.taxNonResidentsLocalPickup}</span>
              </div>
              <div className="cost-row">
                <span>Non Residents &ndash; Shipped via carrier and delivered outside of Canada</span>
                <span className="cost-price">{settings.taxNonResidentsShipped}</span>
              </div>
            </div>
            <p style={{ marginTop: '1rem' }}>
              More info: <a href="http://www.ucda.org/DealerInfo/GstExport.aspx" target="_blank" rel="noopener noreferrer">ucda.org</a>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Shipping;
